import { ApolloCache, DefaultContext, MutationTuple, OperationVariables, useMutation } from '@apollo/client';
import { MetadataTableName } from '@bechtel/sr-types';
import { DeleteCommodityResult } from '~/components';
import {
  DELETE_CABLE,
  DELETE_CABLE_CODE,
  DELETE_COLOR_CODE,
  DELETE_EQUIPMENT,
  DELETE_EQUIPMENT_CODE,
  DELETE_FIRE_AREA,
  DELETE_JUMPER,
  DELETE_PACKAGE,
  DELETE_RACEWAY,
  DELETE_RACEWAY_CODE,
  DELETE_REEL,
} from '~/gql';

export function useDeleteCommodity(
  name: MetadataTableName
): MutationTuple<DeleteCommodityResult, OperationVariables, DefaultContext, ApolloCache<any>> {
  // Set up all the commodity delete mutations here, based on commodity type return the mutation object
  const deleteEquipmentMutation = useMutation(DELETE_EQUIPMENT);
  const deleteEquipmentCodeMutation = useMutation(DELETE_EQUIPMENT_CODE);
  const deleteCableMutation = useMutation(DELETE_CABLE);
  const deleteRacewayMutation = useMutation(DELETE_RACEWAY);
  const deleteJumperMutation = useMutation(DELETE_JUMPER);
  const deleteCableCodeMutation = useMutation(DELETE_CABLE_CODE);
  const deleteRacewayCodeMutation = useMutation(DELETE_RACEWAY_CODE);
  const deleteColorCodeMutation = useMutation(DELETE_COLOR_CODE);
  const deleteFireAreaMutation = useMutation(DELETE_FIRE_AREA);
  const deleteReelMutation = useMutation(DELETE_REEL);
  const deletePackageMutation = useMutation(DELETE_PACKAGE);

  switch (name) {
    case MetadataTableName.EQUIPMENT:
      return deleteEquipmentMutation;
    case MetadataTableName.EQUIPMENT_CODE:
      return deleteEquipmentCodeMutation;
    case MetadataTableName.CABLE:
      return deleteCableMutation;
    case MetadataTableName.RACEWAY:
      return deleteRacewayMutation;
    case MetadataTableName.JUMPER:
      return deleteJumperMutation;
    case MetadataTableName.CABLE_CODE:
      return deleteCableCodeMutation;
    case MetadataTableName.RACEWAY_CODE:
      return deleteRacewayCodeMutation;
    case MetadataTableName.COLOR_CODE:
      return deleteColorCodeMutation;
    case MetadataTableName.REEL:
      return deleteReelMutation;
    case MetadataTableName.FIRE_AREA:
      return deleteFireAreaMutation;
    case MetadataTableName.PACKAGE:
      return deletePackageMutation;
    default:
      return deleteEquipmentMutation;
  }
}
